import { styled } from "@mui/material";
import Styles from "@/assets/styles/Styles";

export const FormContainer = styled("div")`
  background-color: ${Styles.Colors.EDITOR_BACKGROUND_COLOR};
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
